import { render, staticRenderFns } from "./OrgStaffAttorneyStats.vue?vue&type=template&id=0f534fcc&scoped=true&"
import script from "./OrgStaffAttorneyStats.vue?vue&type=script&lang=js&"
export * from "./OrgStaffAttorneyStats.vue?vue&type=script&lang=js&"
import style0 from "./OrgStaffAttorneyStats.vue?vue&type=style&index=0&id=0f534fcc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f534fcc",
  null
  
)

export default component.exports